module.exports = {
          srcSet: __webpack_public_path__ + "a638aed7.jpg"+" 330w",
          images:[ {path: __webpack_public_path__ + "a638aed7.jpg",width: 330,height: 200}],
          src: __webpack_public_path__ + "a638aed7.jpg",
          toString:function(){return __webpack_public_path__ + "a638aed7.jpg"},
          
          width: 330,
          height: 200
        }